import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import some_features from '../../resource/lis_mobile/some_features.png';


const SomeFeaturesMobile = () => {
    return (
        <ProductItemView
            title="Algunas funciones"
            items={["Dashboard customizable por usuario", "Upload de documentos", "Web site mobile friendly para consulta de resultados", "Gestión completa del area de microbiología"]}
            image={some_features} />
    );
};

export default SomeFeaturesMobile;